export const SPECIALITY_TO_ICON = [
  {
    icon: '💻',
    id: '5995b157871fb3a5190aa2fe',
  },
  {
    icon: '📣',
    id: '5995b157871fb3a5190aa303',
  },
  {
    icon: '🎨',
    id: '5995b157871fb3a5190aa300',
  },
  {
    icon: '🙋‍♂',
    id: '5995b157871fb3a5190aa307',
  },
  {
    icon: '📈',
    id: '5995b157871fb3a5190aa304',
  },
  {
    icon: '💆',
    id: '59b8dae0d4841f1d116392cb',
  },
  {
    icon: '📊',
    id: '5995b157871fb3a5190aa2ff',
  },
  {
    icon: '👾',
    id: '5995b157871fb3a5190aa301',
  },
  {
    icon: '👔',
    id: '5995b157871fb3a5190aa302',
  },
  {
    icon: '🧑🏽‍⚖️',
    id: '5995b157871fb3a5190aa306',
  },
  {
    icon: '👩🏼‍💼',
    id: '59c172c27fd8f1c6796b5526',
  },
  {
    icon: '👷🏽‍♀️',
    id: '5de2de28b8d1dc6e8a876da6',
  },
  {
    icon: '🖋️',
    id: '5de2de27b8d1dc6e8a876da3',
  },
  {
    icon: '🗂️',
    id: '5de2de27b8d1dc6e8a876da2',
  },
  {
    icon: '🗺️',
    id: '5de2de29b8d1dc6e8a876da7',
  },
  {
    icon: '🏷️',
    id: '5de2de27b8d1dc6e8a876da4',
  },
  {
    icon: '🛎️',
    id: '5de2de28b8d1dc6e8a876da5',
  },
  {
    icon: '🏡',
    id: '5de2de2ab8d1dc6e8a876da8',
  },
  {
    icon: '🦺',
    id: '5de2de2ab8d1dc6e8a876da9',
  },
];
